// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"59ccd9b7","983":"59ccd9b7"}[chunkId] + ".chunk.css";
};